
// CREDENCIALES
export const enviroment = 'api'
export const apiRootLogin = 'https://' + enviroment + '.interactvty.com/'
export const apiRoot = 'https://' + enviroment + '.interactvty.com/api/1.0/'
export const apiRootAzure = ''
export const clientId = '4MTnCuQ8pYrYdbm7WWtDb7sCYR3BXR8Q0RNXq4ys'
export const username = 'brochero_demo'
export const password = 'EgDzKpJI'

// PLATFORM
export const platform = 'browser' // browser / tv

// VARS
export const sideMenuBrowser = false

// SENTRY
export const sentryUrl = 'https://deb146365a2e4999be540450c8555dfa@sentry.io/1357590'
export const sentryActive = true

// ANALYTICS
export const statsActive = true
// export const StatsIntro = "Intro";
export const StatsRootContentCategories = 'RootContentCategories'
export const StatsCategoryDetail = 'CategoryDetail'
export const StatsCategoryTailler = 'CategoryTailler'
export const StatsContentCategory = 'ContentCategory'
export const StatsContentDetail = 'ContentDetail'
export const StatsContentTailler = 'ContentTailler'
export const StatsContentView = 'ContentView'
export const StatsLiveCategories = 'LiveCategories'
export const StatsPlain = 'Plain'
export var StatsTest = 'Test'

export var StatsRootProductCategories = 'RootProductCategories'
export var StatsProductCategory = 'ProductCategory'
export var StatsProductDetail = 'ProductDetail'

export var StatsRootCart = 'Cart'

export const StatsRootSettings = 'Settings'

// Stats Events
// export const StatsCartPurchase = 'CartPurchase'
// export const StatsDirectPurchase = 'DirectPurchase'
// export const StatsInAppPurchase = 'InAppPurchase'
export const StatsShowInteractivity = 'ShowInteractivity'
export const StatsClickInteractivity = 'ClickInteractivity'
export const StatsAds = 'Ads'



// WEBPACK FOOTER //
// ./src/utils/constants.js